import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { Spin } from 'antd';
import { LibraryFolderList, LibraryFolderItems, SelectedLibraryItems } from '..';

import './ContentLibrary.scss';

const ContentLibrary = ({
  selectedItems,
  setSeletedItem,
  copying,
  showSelectedFiles = true,
  showBack,
  setShowBack,
  showFileTypes = [],
  span = 12,
  type,
  multiSelect = true,
}) => {
  const [selectedFolderListItem, setSelectedFolderListItem] = useState('all');
  const navRef = useRef(null);

  const selectedItemsArr = Object.values(selectedItems);
  const removeItem = (item) => {
    const { [item.src]: _, ...rest } = selectedItems;
    setSeletedItem(rest);
  };

  useEffect(() => {
    if (setShowBack && selectedFolderListItem) {
      setShowBack(2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFolderListItem]);

  return (
    <div className={`library-modal-container ${copying ? 'item-copying' : ''}`}>
      {copying ? (
        <Spin />
      ) : (
        <>
          <div
            className={`nav-section ${showBack ? `screen-${showBack}` : 'screen-1'}`}
            ref={navRef}>
            <div>
              <div className="nav-section-col" key={selectedFolderListItem}>
                <LibraryFolderList
                  type="medias"
                  selectedFolder={selectedFolderListItem}
                  setSelectedFolder={(f) => {
                    setSelectedFolderListItem(f);
                    setTimeout(() => navRef?.current?.scroll(10000, 0), 100);
                  }}
                />

                <LibraryFolderItems
                  type="medias"
                  selectedFolder={selectedFolderListItem}
                  selectedItems={selectedItems}
                  showFileTypes={showFileTypes}
                  addToSeletedItem={(m) => {
                    if (!(m.src in selectedItems)) {
                      setSeletedItem({
                        ...selectedItems,
                        [m.src]: m,
                      });
                    } else {
                      removeItem(m);
                    }
                  }}
                  span={span}
                  coverType={type}
                  multiSelect={multiSelect}
                />
              </div>
            </div>
          </div>

          {showSelectedFiles && (
            <SelectedLibraryItems
              selectedItemsArr={selectedItemsArr}
              removeItem={removeItem}
              multiSelect={multiSelect}
            />
          )}
        </>
      )}
    </div>
  );
};

ContentLibrary.defaultProps = {
  selectedItems: {},
  setSeletedItem: () => {},
  copying: false,
  showSelectedFiles: true,
  showBack: 0,
  setShowBack: () => {},
  showFileTypes: [],
  span: 12,
  type: 'medias',
  multiSelect: false,
};

ContentLibrary.propTypes = {
  selectedItems: PropTypes.object,
  setSeletedItem: PropTypes.func,
  copying: PropTypes.bool,
  showSelectedFiles: PropTypes.bool,
  showBack: PropTypes.number,
  setShowBack: PropTypes.func,
  showFileTypes: PropTypes.array,
  span: PropTypes.number,
  type: PropTypes.string,
  multiSelect: PropTypes.bool,
};

export default ContentLibrary;
